import { map as map_1, defaultArg, orElse } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Caption1, Subtitle2, CardHeader, Caption2, ProgressBar, Badge, Body1Strong, Card, Caption1Strong, Link, CardFooter, tokens, CardPreview } from "@fluentui/react-components";
import { createElement } from "react";
import React from "react";
import { int32ToString, numberHash, comparePrimitives, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { BookOpenRegular, LayerRegular, ChevronRightRegular, ArrowRightRegular, HatGraduationRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { printf, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FSharpSet__Contains, ofArray as ofArray_1 } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { sumBy, tryFind, append as append_1, collect, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { Array_distinctBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { max } from "../fable_modules/fable-library-js.4.29.0/Double.js";

function trackImageOf(track) {
    return orElse(track.ThumbnailUrl, track.ImageUrl);
}

function cardPreviewBlock(isMobile, trackName, image) {
    let elems;
    const el_2 = CardPreview;
    return createElement(el_2, createObj(ofArray([["style", createObj(toList(delay(() => append(isMobile ? singleton(["height", 90 + "px"]) : append(singleton(["width", 140 + "px"]), delay(() => append(singleton(["flexShrink", 0]), delay(() => singleton(["alignSelf", "stretch"]))))), delay(() => append(singleton(["backgroundColor", tokens.colorBrandBackground2]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => singleton(["overflow", "hidden"]))))))))))))))], (elems = toList(delay(() => {
        let el;
        return (image == null) ? singleton((el = HatGraduationRegular, createElement(el, {
            fontSize: 32,
            primaryFill: tokens.colorBrandForeground1,
        }))) : singleton(createElement("img", {
            src: image,
            alt: trackName,
            style: {
                width: 100 + "%",
                height: 100 + "%",
                objectFit: "cover",
                display: "block",
            },
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function descriptionBlock(description) {
    if (isNullOrWhiteSpace(description)) {
        return defaultOf();
    }
    else {
        return createElement("div", {
            style: {
                color: tokens.colorNeutralForeground2,
                fontSize: 12 + "px",
                lineHeight: 1.5,
                overflowWrap: "anywhere",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
            },
            children: description,
        });
    }
}

function footerLink(label, href) {
    let elems_1, el_4, elems, el, el_2;
    const el_6 = CardFooter;
    return createElement(el_6, createObj(ofArray([["style", {
        justifyContent: "flex-end",
    }], (elems_1 = [(el_4 = Link, createElement(el_4, {
        href: href,
        children: createElement("span", createObj(ofArray([["style", {
            display: "inline-flex",
            alignItems: "center",
            gap: 4 + "px ",
        }], (elems = [(el = Caption1Strong, createElement(el, {
            children: label,
        })), (el_2 = ArrowRightRegular, createElement(el_2, {
            fontSize: 16,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Enrolled(enrolledInputProps) {
    let elems_4, el_12, elems_3, elems, elems_2, elems_1, el_2, el_4, arg_1, el_6, el_8, el_10, elems_8, elems_7, el_18, el_14, el_16, arg_6, elems_6, el_20, elems_5, el_22, el_24;
    const et = enrolledInputProps.et;
    const userCompletedTasks = enrolledInputProps.userCompletedTasks;
    const isMobile = enrolledInputProps.isMobile;
    const completedTaskSet = ofArray_1(map((ct) => ct.Task.Id, userCompletedTasks, Int32Array), {
        Compare: comparePrimitives,
    });
    const allTrackTasks = Array_distinctBy((_arg_1) => _arg_1.Id, collect((lvl) => append_1(collect((_arg) => _arg.Course.Tasks, lvl.TrackLevelCourses), lvl.Tasks), et.Track.TrackLevels), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: numberHash,
    });
    const trackTotalTasks = allTrackTasks.length | 0;
    let trackCompletedTasks;
    const array_6 = allTrackTasks.filter((t) => FSharpSet__Contains(completedTaskSet, t.Id));
    trackCompletedTasks = array_6.length;
    const pct = (trackTotalTasks === 0) ? 0 : (trackCompletedTasks / trackTotalTasks);
    const totalLevels = et.Track.TrackLevels.length | 0;
    const levelOrder = defaultArg(map_1((_arg_2) => _arg_2.Order, tryFind((l) => (l.Id === et.CurrentTrackLevelId), et.Track.TrackLevels)), 0) | 0;
    const href = RouterModule_encodeParts(ofArray(["laeringslop", int32ToString(et.Track.Id)]), 1);
    const pctInt = ~~(pct * 100) | 0;
    if (isMobile) {
        return createElement("a", createObj(ofArray([["href", href], ["style", {
            textDecoration: "none",
            color: "inherit",
            display: "block",
        }], (elems_4 = [(el_12 = Card, createElement(el_12, createObj(ofArray([["style", {
            minWidth: 0,
            overflow: "hidden",
            padding: 12,
            flexDirection: "row",
            alignItems: "center",
            gap: 12 + "px ",
        }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
            width: 72,
            height: 72,
            flexShrink: 0,
            borderRadius: 6,
            overflow: "hidden",
            backgroundColor: tokens.colorBrandBackground2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }], (elems = toList(delay(() => {
            let el;
            const matchValue = trackImageOf(et.Track);
            return (matchValue == null) ? singleton((el = HatGraduationRegular, createElement(el, {
                fontSize: 28,
                primaryFill: tokens.colorBrandForeground1,
            }))) : singleton(createElement("img", {
                src: matchValue,
                alt: et.Track.Name,
                style: {
                    width: 100 + "%",
                    height: 100 + "%",
                    objectFit: "cover",
                    display: "block",
                },
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            flexGrow: 1,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            gap: 4 + "px ",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 6 + "px ",
            minWidth: 0,
        }], (elems_1 = [(el_2 = Body1Strong, createElement(el_2, {
            style: {
                flexGrow: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            },
            children: et.Track.Name,
        })), (el_4 = Badge, createElement(el_4, {
            size: "small",
            appearance: "tint",
            color: "brand",
            style: {
                whiteSpace: "nowrap",
                flexShrink: 0,
            },
            children: (arg_1 = (max(totalLevels, 1) | 0), toText(printf("Nivå %d/%d"))(levelOrder)(arg_1)),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))), (el_6 = ProgressBar, createElement(el_6, {
            value: pct,
            thickness: "medium",
            shape: "rounded",
            color: "brand",
        })), (el_8 = Caption2, createElement(el_8, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: toText(printf("%d/%d oppgaver · %d%%"))(trackCompletedTasks)(trackTotalTasks)(pctInt),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))), (el_10 = ChevronRightRegular, createElement(el_10, {
            fontSize: 20,
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
    }
    else {
        const el_26 = Card;
        return createElement(el_26, createObj(ofArray([["orientation", "horizontal"], ["style", {
            minWidth: 0,
            overflow: "hidden",
        }], (elems_8 = [cardPreviewBlock(isMobile, et.Track.Name, trackImageOf(et.Track)), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 8 + "px ",
            flexGrow: 1,
            minWidth: 0,
        }], (elems_7 = [(el_18 = CardHeader, createElement(el_18, {
            header: (el_14 = Subtitle2, createElement(el_14, {
                style: {
                    wordBreak: "break-word",
                },
                children: et.Track.Name,
            })),
            action: (el_16 = Badge, createElement(el_16, {
                size: "small",
                appearance: "tint",
                color: "brand",
                style: {
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                },
                children: (arg_6 = (max(totalLevels, 1) | 0), toText(printf("Nivå %d/%d"))(levelOrder)(arg_6)),
            })),
        })), descriptionBlock(et.Track.Description), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 6 + "px ",
        }], (elems_6 = [(el_20 = ProgressBar, createElement(el_20, {
            value: pct,
            thickness: "large",
            shape: "rounded",
            color: "brand",
        })), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
            flexWrap: "wrap",
        }], (elems_5 = [(el_22 = Caption1Strong, createElement(el_22, {
            style: {
                color: tokens.colorNeutralForeground2,
            },
            children: toText(printf("%d%% fullført"))(pctInt),
        })), (el_24 = Caption1, createElement(el_24, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: `· ${trackCompletedTasks} av ${trackTotalTasks} oppgaver`,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))), footerLink("Fortsett", href)], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
    }
}

export function General(generalInputProps) {
    const track = generalInputProps.track;
    const isMobile = generalInputProps.isMobile;
    const href = RouterModule_encodeParts(ofArray(["laeringslop", int32ToString(track.Id)]), 1);
    const el_14 = Card;
    return createElement(el_14, createObj(toList(delay(() => append(isMobile ? singleton(["orientation", "vertical"]) : singleton(["orientation", "horizontal"]), delay(() => append(singleton(["style", {
        minWidth: 0,
        overflow: "hidden",
    }]), delay(() => {
        let elems_4, elems_3;
        return singleton((elems_4 = [cardPreviewBlock(isMobile, track.Name, trackImageOf(track)), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 8 + "px ",
            flexGrow: 1,
            minWidth: 0,
        }], (elems_3 = toList(delay(() => {
            let el_4;
            return append(singleton((el_4 = CardHeader, createElement(el_4, createObj(toList(delay(() => {
                let el;
                return append(singleton(["header", (el = Subtitle2, createElement(el, {
                    style: {
                        wordBreak: "break-word",
                    },
                    children: track.Name,
                }))]), delay(() => {
                    let el_2;
                    return !track.Enabled ? singleton(["action", (el_2 = Badge, createElement(el_2, {
                        size: "small",
                        appearance: "tint",
                        color: "warning",
                        style: {
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                        },
                        children: "Utkast",
                    }))]) : empty();
                }));
            })))))), delay(() => append(singleton(descriptionBlock(track.Description)), delay(() => {
                let elems_2, elems, el_6, el_8, arg, elems_1, el_10, el_12;
                const courseCount = sumBy((_arg) => _arg.TrackLevelCourses.length, track.TrackLevels, {
                    GetZero: () => 0,
                    Add: (x, y) => (x + y),
                }) | 0;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 16 + "px ",
                    flexWrap: "wrap",
                    color: tokens.colorNeutralForeground3,
                }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 4 + "px ",
                }], (elems = [(el_6 = LayerRegular, createElement(el_6, {
                    fontSize: 16,
                })), (el_8 = Caption1, createElement(el_8, {
                    children: (arg = (track.TrackLevels.length | 0), toText(printf("%d nivåer"))(arg)),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 4 + "px ",
                }], (elems_1 = [(el_10 = BookOpenRegular, createElement(el_10, {
                    fontSize: 16,
                })), (el_12 = Caption1, createElement(el_12, {
                    children: toText(printf("%d kurs"))(courseCount),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), delay(() => singleton(footerLink("Se mer", href))));
            }))));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]));
    }))))))));
}

//# sourceMappingURL=TrackCard.jsx.map
